import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Workouts from "./pages/Workouts";
import Weight from "./pages/Weight";
import Reminders from "./pages/Reminders";
import Coach from "./pages/Coach";
import Plans from "./pages/Plans";
import Account from "./pages/Account";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AppShell from "./components/AppShell";

function Loader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
      <div className="h-1 w-40 bg-[#1A1A1A] overflow-hidden">
        <div className="h-full w-1/3 bg-[#FF3B30]" style={{ animation: "loading 1s linear infinite" }} />
      </div>
    </div>
  );
}

// Requires login only (used for /plans, /payment/*)
function LoggedIn({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

// Requires login + active subscription (trial or paid)
function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!user.has_app_access) return <Navigate to="/plans" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/plans" element={<LoggedIn><Plans /></LoggedIn>} />
            <Route path="/payment/success" element={<LoggedIn><PaymentSuccess /></LoggedIn>} />
            <Route path="/payment/cancel" element={<LoggedIn><PaymentCancel /></LoggedIn>} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/workouts" element={<Protected><Workouts /></Protected>} />
            <Route path="/weight" element={<Protected><Weight /></Protected>} />
            <Route path="/reminders" element={<Protected><Reminders /></Protected>} />
            <Route path="/coach" element={<Protected><Coach /></Protected>} />
            <Route path="/account" element={<Protected><Account /></Protected>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
